export default __webpack_public_path__ + "static/media/IconToReceive.758f3949.svg";